module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('bdialog', {
    attrs: {
      "config": _vm.bconfig
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_helptip'),
      "size": ""
    },
    model: {
      value: (_vm.pushState),
      callback: function($$v) {
        _vm.pushState = $$v
      },
      expression: "pushState"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "840px"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#48576A",
      "font-size": "18px",
      "margin-top": "-6px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_newpsetnewver')))]), _vm._v(" "), _c('p', {
    staticClass: "gTopMg",
    staticStyle: {
      "line-height": "25px"
    }
  }, [_vm._v("    " + _vm._s(_vm.$t('app_newptdetail')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "line-height": "25px"
    }
  }, [_vm._v("    " + _vm._s(_vm.$t('app_newptdetail1')))]), _vm._v(" "), _c('img', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.pic1
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.pic2
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.pic3
    }
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.imgLogo) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.imgLogo
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "logoTxt"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t('lin_global.logoTitle')) + "\n\t\t")])]), _vm._v(" "), _c('el-col', {
    staticClass: "rightbar",
    attrs: {
      "span": 12
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link",
    staticStyle: {
      "color": "#fff",
      "cursor": "pointer"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('lin_global.hello')) + ", " + _vm._s(_vm.nickname) + "\n\t\t\t\t\t"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "m"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.wdzl')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "o"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.tcxt')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24,
      "id": "container"
    }
  }, [_c('aside', {
    attrs: {
      "id": "aside"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "default-active": _vm.currentNav,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose,
      "select": _vm.handleSelect
    }
  }, [_vm._l((_vm.menuList), function(item, index) {
    return (!item.hidden) ? [(!item.leaf && item.children && item.children.length > 0) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.meta) ? _c('i', {
      class: item.meta.iconCls,
      staticStyle: {
        "margin-right": "10px"
      }
    }) : _vm._e(), _vm._v(_vm._s(item.name) + "\n            ")]), _vm._v(" "), _vm._l((item.children), function(child, index) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: index,
        staticClass: "smn",
        staticStyle: {
          "background": "white"
        },
        attrs: {
          "index": child.path
        }
      }, [_vm._v("\n                " + _vm._s(child.name) + "\n            ")]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [
      [(item.meta) ? _c('i', {
        class: item.meta.iconCls,
        staticStyle: {
          "margin": "0 5px 0 -4px"
        }
      }) : _vm._e(), _vm._v(_vm._s(item.children[0].name) + "\n            ")]
    ], 2) : _vm._e()] : _vm._e()
  })], 2)], 1), _c('section', {
    attrs: {
      "id": "conter"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('BreadCrumb')], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-bottom": "24px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('router-view')], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e12edc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 1020
// module chunks = 0